"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var sanitizeState_1 = __importDefault(require("../helpers/sanitizeState"));
var StaticErrorView_1 = __importDefault(require("../components/errorViews/StaticErrorView"));
var wikom_data_1 = require("@wikom/wikom-data");
var ErrorHandler = function (_a) {
    var errorViewComponent = _a.errorViewComponent, error = _a.error, stateReport = _a.stateReport, sendReportToBackend = _a.sendReportToBackend;
    (0, react_1.useEffect)(function () {
        sendReportToBackend(error, stateReport);
    }, []);
    return react_1["default"].createElement(errorViewComponent, { error: error });
};
var mapStateToProps = function (state, _a) {
    var sanitizeFn = _a.sanitizeFn;
    return ({
        stateReport: sanitizeFn(state)
    });
};
var mapDispatchToProps = function (dispatch, _a) {
    var apiUrl = _a.apiUrl;
    return ({
        sendReportToBackend: function (error, stateReport) {
            if (apiUrl) {
                // @ts-ignore
                dispatch((0, wikom_data_1.submit)({
                    url: apiUrl,
                    data: {
                        error: error.error.toString(),
                        stack: error.error.stack,
                        info: JSON.stringify(error.info),
                        state: JSON.stringify(stateReport)
                    }
                }))
                    .then(function () { return null; })["catch"](function (error) { return null; });
            }
        }
    });
};
var ConnectedErrorHandler = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(ErrorHandler);
/**
 *
 */
var ErrorHandlerContainer = /** @class */ (function (_super) {
    __extends(ErrorHandlerContainer, _super);
    function ErrorHandlerContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { error: null };
        return _this;
    }
    ErrorHandlerContainer.prototype.componentDidCatch = function (error, info) {
        this.setState({ error: { error: error, info: info } });
    };
    ErrorHandlerContainer.prototype.render = function () {
        if (this.state.error !== null) {
            return (react_1["default"].createElement(ConnectedErrorHandler, { errorViewComponent: this.props.errorViewComponent, error: this.state.error, sanitizeFn: this.props.sanitizeFn, apiUrl: this.props.apiUrl }));
        }
        else {
            return this.props.children;
        }
    };
    ErrorHandlerContainer.defaultProps = {
        errorViewComponent: StaticErrorView_1["default"],
        sanitizeFn: sanitizeState_1["default"]
    };
    return ErrorHandlerContainer;
}(react_1["default"].Component));
exports["default"] = ErrorHandlerContainer;
